import styled from "@emotion/styled";

import UIcon from "../../../lib/icons/untitled_ui/UIcon";
import { Flex, Text } from "../../../styles/utility-components";

/**
 * Used on bid report components to indicate that content is actively being generated by the AI.
 * @returns
 */
export function LoadingContent({ marginTop }: { marginTop?: number }) {
  return (
    <Container marginTop={marginTop}>
      <UIcon icon="spinner" size={16} color="sysPrimaryDefault" />
      <Text color="sysTextPlaceholder">Generating...</Text>
    </Container>
  );
}

const Container = styled(Flex)<{ marginTop?: number }>(({ marginTop }) => ({
  gap: 8,
  alignItems: "center",
  marginTop,
}));
